import snakecaseKeys from 'snakecase-keys'
import client from '../../client'
import { ApiResponse, PagerMeta } from '../../types'
import { ListParams, ListTimetableItem, TimetableId } from './types'

export * from './types'

export const list = async (params: ListParams) => {
  const { data, meta }: ApiResponse<ListTimetableItem[], PagerMeta> =
    await client.get(`/user/timetables`, {
      params: snakecaseKeys({
        ...params,
        showFullReservations: params.showFullReservations ? 1 : 0,
        isOnline: params.isOnline ? 1 : 0,
      }),
    })
  return { data, meta }
}

export const isReservable = async (id: TimetableId) => {
  return await client.get(`/user/timetables/isReservable/${id}`)
}
